const common = {
  siteTitle: 'Information security system',
  notFound: 'Not found',
  confirm: 'Confirm',
  cancel: 'Cancel',
  exportExcel: 'Export Excel',
  addNew: 'Add New',
  search: 'Search',
  filter: 'Filter',
  upload: 'Upload',
  url: 'URL',
  clickToUpload: 'Click to upload',
  dragAndDrop: 'or drag and drop',
  required: 'SVG, PNG, JPG or GIF, MP4 (Up to 20MB)',
  enterLink: 'Enter link',
  close: 'Close',
  changePassword: 'Change password',
  logout: 'Logout',

  // Sidebar - Dashboard
  dashboardGroup: 'Dashboard',
  dashboardHome: 'Home',
  dashboardDevice: 'Device Dashboard',
  dashboardBody: 'Body Dashboard',
  dashboardVibration: 'Vibration Dashboard',
  dashboardLaser: 'Laser Machine Dashboard',
  dashboardMaintenance: 'Maintenance Overview',
  dashboardIncident: 'Incident Dashboard',
  dashboardIncidentList: 'Incident List',
  dashboardErrorLogList: 'Operation Error Logs',
  dashboardMaterial: 'Material Dashboard',
  dashboardFeature: 'Feature Dashboard',
  dashboardAnalytics: 'Analytics Dashboard',

  // Sidebar - Configuration
  configGroup: 'Configuration',
  machineTypeManage: 'Machine Type',
  connectionProtocolManage: 'Connection Protocol',
  unitManage: 'Unit',
  deviceManage: 'Device',
  mailConfigManage: 'Mail Configuration',

  // Sidebar - System
  systemManage: 'System',
  userManage: 'User',
  roleManage: 'Role',

  breadcrumb: {
    home: 'Home',
    dashboard: 'Dashboard',
    targetGroup: 'Target Group'
  }
};

export default common;
